import SettingsBodyWrapper from './SettingsBodyWrapper';
export default SettingsBodyWrapper;
